import { requestWithToken as request } from "./api";

export const getCarteraAnalista = () =>
    request.get(
        `/analyst_view/get_all/`
    );

export function getUploadedFiles(company_id, file_id, page) {
    const result = request.get(
        `/analyst_view/${company_id}/all_uploads/?page=${page}&file_id=${file_id}`
    );
    return result;
}

export const getDetalleCompania = (id) =>
    request.get(
        `/analyst_view/${id}/complementary_data/`
    );

export const getFileData = (id) =>
    request.get(
        `/analyst_view/${id}/file_data/`
    );

export const getFirstRows = (id) =>
    request.get(
        `/analyst_view/${id}/load_first_rows/`
    );

export const grabarConfiguracion = (id, params = {}) => {
    return request.post(`/analyst_view/${id}/save_configuration/`,
        params)
    }
      